import { FunctionComponent } from 'react';
import 'chart.js/auto';
import { Line } from 'react-chartjs-2';
import { TooltipItem, ChartType } from 'chart.js';

export type LineChartSingleProps = {
  options: {
    label: string;
    fill: boolean;
    borderColor: string;
    tension: number;
  };
  data: {
    label: string;
    value: string | number;
  }[];
};

type FC = FunctionComponent<LineChartSingleProps>;

const LineChartSingle: FC = ({ data, options }: LineChartSingleProps) => {
  return (
    <Line
      data={{
        labels: data.map((item) => item.label),
        datasets: [
          {
            ...options,
            data: data.map((item) => item.value),
          },
        ],
      }}
      options={{
        responsive: true,
        maintainAspectRatio: false,
        interaction: {
          mode: 'nearest' as const, // Show tooltips for all datasets at the same index
          intersect: false, // Show tooltips at the point of intersection with the cursor
        },
        scales: {
          x: {
            ticks: {
              color: '#5E5E5E',
            },
            grid: {
              display: false,
            },
          },
          y: {
            ticks: {
              maxTicksLimit: 6,
              color: '#5E5E5E',
            },
            grid: {
              display: true,
              color: '#EFEFEF',
            },
          },
        },
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            callbacks: {
              title(context: TooltipItem<ChartType>[]) {
                const title = context[0].label || '';
                return `${title}`;
              },
              label() {
                return '';
              },
              footer(context: TooltipItem<ChartType>[]) {
                const title = context[0].dataset.data[context[0].dataIndex]?.toString() || '';
                return `Transactions : ${title.toString()}`;
              },
            },
            padding: {
              left: 10,
              right: 10,
              top: 8,
              bottom: 3,
            },
            backgroundColor: '#2D2D2D',
            titleColor: '#FBFBFB',
            titleFont: {
              size: 12,
            },
            titleAlign: 'center' as const,
            footerFont: {
              size: 14,
              weight: 700,
            },
            footerAlign: 'center' as const,
            footerMarginTop: -2,
            bodyAlign: 'center' as const,
            bodyColor: '#2D2D2D',
            displayColors: false,
            caretSize: 6,
            borderColor: 'none',
            cornerRadius: 3,
          },
        },
      }}
    />
  );
};

export default LineChartSingle;
